function initMachineryCards(){

    MicroModal.init({
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
    });
    
    // Function that builds Types Sliders
    const buildImgSlider = sliderElm => {
        const sliderIdentifier = sliderElm.dataset.id;
        return new Swiper(`.img-slider[data-id="${sliderIdentifier}"]`, {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 20,
            a11y: true,
            loop: false,
            grabCursor: true,
            watchSlidesProgress: true,
    
            navigation: {
                nextEl: `.button-next-${sliderIdentifier}`,
                prevEl: `.button-prev-${sliderIdentifier}`,
            },
    
            preloadImages: false,
            lazy: true,
    
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            breakpoints: {
                1024: {
                  slidesPerView: 2,
                },
            },
        });
    }
    
    // Get all of the types sliders on the page
    const allImgSliders = document.querySelectorAll('.img-slider');
    
    // Loop over all of the fetched sliders and apply Swiper on each one.
    allImgSliders.forEach(slider => buildImgSlider(slider));

    let productEnquire = document.querySelectorAll('.view-enquire')
    for (var i = 0; i < productEnquire.length; i++) {
      productEnquire[i].addEventListener('click', contactFill, false);
    }
};

initMachineryCards();